export enum SectionsAccess {
    All = ~0,
    None = 0,
    Funds = 1,
    Assets = 2,
    Insights = 4,
    Contacts = 8,
    Positions = 16,
    BankAccounts = 32
}


export namespace SectionsAccess {
  export function toString(sectionsAccess: SectionsAccess): string {
    switch (sectionsAccess) {
      case SectionsAccess.All:
        return 'All';
      case SectionsAccess.None:
        return 'None';
      case SectionsAccess.Funds:
        return 'Funds';
      case SectionsAccess.Assets:
        return 'Assets';
      case SectionsAccess.Insights:
        return 'Insights';
      case SectionsAccess.Contacts:
        return 'Contacts';
      case SectionsAccess.Positions:
        return 'Positions';
      case SectionsAccess.BankAccounts:
        return 'Bank Accounts';
      default:
        return null;
    }
  }

  export function listAll(withNone = false): SectionsAccess[] {
    if(withNone){
      return [SectionsAccess.All, SectionsAccess.None, SectionsAccess.Funds, SectionsAccess.Assets, SectionsAccess.Insights,
        SectionsAccess.Contacts, SectionsAccess.Positions, SectionsAccess.BankAccounts];
    }
    return [SectionsAccess.All, SectionsAccess.Funds, SectionsAccess.Assets, SectionsAccess.Insights,
      SectionsAccess.Contacts, SectionsAccess.Positions, SectionsAccess.BankAccounts];
  }

  export function parse(sf: string): SectionsAccess {
    return SectionsAccess[sf];
  }

  export function isOn(sectionsAccess: SectionsAccess, valueToCheck: SectionsAccess): boolean {
    return valueToCheck === (sectionsAccess & valueToCheck);
  }

  export function convertToListString(sectionsAccess: SectionsAccess, withNone = false) {
    const allFlags = listAll(withNone);
    const filterFlags = allFlags.filter(f => isOn(sectionsAccess, f));
    return filterFlags.map(f => toString(f));
  }

  export function convertToFlags(sectionsAccess: SectionsAccess[]) {
    if (sectionsAccess.includes(SectionsAccess.All)) {
      return SectionsAccess.All;
    }

    return sectionsAccess.reduce((sum, current) => sum + current, 0);
  }
}

export default SectionsAccess;

